export default __webpack_public_path__ + "static/ringType6-76ef8413c184cf777e9c4119f55a9ece.png";